import { Crypto } from './getLiveChatParams';
const isDev = process.env.NODE_ENV === 'development';
export var LiveChatUserLanguage;
(function (LiveChatUserLanguage) {
    LiveChatUserLanguage["pl"] = "pl";
    LiveChatUserLanguage["ru"] = "ru";
    LiveChatUserLanguage["en"] = "en";
})(LiveChatUserLanguage || (LiveChatUserLanguage = {}));
export class LiveChatSkill {
}
LiveChatSkill.EN_CUSTOMER = isDev ? '12' : '1';
LiveChatSkill.PL_CUSTOMER = isDev ? '19' : '7';
LiveChatSkill.EN_VISITOR = '9';
LiveChatSkill.PL_VISITOR = '10';
LiveChatSkill.ENTERPRISE_EN_CUSTOMER = isDev ? '24' : '23';
LiveChatSkill.EN_FREE_CUSTOMER = isDev ? '31' : '28';
LiveChatSkill.PL_FREE_CUSTOMER = isDev ? '31' : '29';
LiveChatSkill.ENTERPRISE_PL_CUSTOMER = isDev ? '33' : '32';
export const getLiveChatSkill = (payload) => {
    const { language, account } = payload;
    const isVisitor = account === undefined;
    if (isVisitor) {
        return language === LiveChatUserLanguage.pl ? LiveChatSkill.PL_VISITOR : LiveChatSkill.EN_VISITOR;
    }
    const isEnterprise = (account === null || account === void 0 ? void 0 : account.crypto) !== Crypto.GETRESPONSE && (account === null || account === void 0 ? void 0 : account.crypto) !== '';
    if (isEnterprise) {
        return language === LiveChatUserLanguage.pl
            ? LiveChatSkill.ENTERPRISE_PL_CUSTOMER
            : LiveChatSkill.ENTERPRISE_EN_CUSTOMER;
    }
    if (account === null || account === void 0 ? void 0 : account.isFree) {
        return language === LiveChatUserLanguage.pl ? LiveChatSkill.PL_FREE_CUSTOMER : LiveChatSkill.EN_FREE_CUSTOMER;
    }
    return language === LiveChatUserLanguage.pl ? LiveChatSkill.PL_CUSTOMER : LiveChatSkill.EN_CUSTOMER;
};
